import Home from "./home.json";
import Header from "./header.json";
import Footer from "./footer.json";
import Login from "./login.json";
import SignUp from "./signup.json";
import Book from "./book.json";
import Mypage from "./mypage.json";
import Alert from "./alert.json";
import Comm from "./comm.json";
import Lod from "./lod.json";

const ko = {
  ...Home,
  ...Header,
  ...Footer,
  ...Login,
  ...SignUp,
  ...Book,
  ...Mypage,
  ...Alert,
  ...Comm,
  ...Lod,
};

export default ko;
